/* OREN — Welle 10: Patina ID + Returning Customer */
(function(){
  const PATINA_KEY = 'oren_patina_id';
  const PATINA_SINCE_KEY = 'oren_patina_since';
  const PATINA_TIER_KEY = 'oren_patina_tier';
  const PATINA_PURCHASES_KEY = 'oren_patina_purchases';
  const RETURNING_DISMISSED_KEY = 'oren_returning_dismissed';

  function getInt(key, fallback){
    try{ const v = localStorage.getItem(key); return v ? parseInt(v, 10) : fallback; }catch(e){ return fallback; }
  }
  function setVal(key, val){
    try{ localStorage.setItem(key, val); }catch(e){}
  }
  function getVal(key){
    try{ return localStorage.getItem(key); }catch(e){ return null; }
  }
  function pad(n){ return String(n).padStart(4, '0'); }
  function ordinal(n){
    const map = {1:'first',2:'second',3:'third',4:'fourth',5:'fifth',6:'sixth',7:'seventh',8:'eighth',9:'ninth',10:'tenth'};
    if(map[n]) return map[n];
    const j = n % 10, k = n % 100;
    if(j == 1 && k != 11) return n + 'st';
    if(j == 2 && k != 12) return n + 'nd';
    if(j == 3 && k != 13) return n + 'rd';
    return n + 'th';
  }

  function getTier(purchases){
    if(purchases >= 5) return 'cellar';
    if(purchases >= 2) return 'cabinet';
    if(purchases >= 1) return 'drawer';
    return null;
  }

  /* ============================================
     ASSIGN PATINA ID ON ORDER CONFIRMATION
     Triggered when on /thank_you / orders pages, or when first_purchase flag detected
     ============================================ */
  function assignPatinaIdIfNeeded(){
    const isThankYou = location.pathname.includes('/thank') ||
                       location.pathname.includes('/orders/') ||
                       document.body.classList.contains('template-customers-order') ||
                       (document.querySelector('[data-order-confirmation]') !== null);
    if(!isThankYou) return;

    let id = getInt(PATINA_KEY, 0);
    if(id === 0){
      const section = document.querySelector('[data-patina-id-section]');
      if(!section) return;
      const startCounter = parseInt(section.getAttribute('data-shop-patina-counter') || '7', 10);
      id = startCounter;
      setVal(PATINA_KEY, id);
      setVal(PATINA_SINCE_KEY, new Date().getFullYear());
      setVal(PATINA_PURCHASES_KEY, 1);
      setVal(PATINA_TIER_KEY, 'drawer');
    }else{
      const purchases = (getInt(PATINA_PURCHASES_KEY, 0)) + 1;
      setVal(PATINA_PURCHASES_KEY, purchases);
      setVal(PATINA_TIER_KEY, getTier(purchases));
    }
  }

  /* ============================================
     RENDER PATINA ID ON PAGE
     ============================================ */
  function renderPatinaId(){
    const section = document.querySelector('[data-patina-id-section]');
    if(!section) return;

    const id = getInt(PATINA_KEY, 0);
    if(id === 0){
      const startCounter = parseInt(section.getAttribute('data-shop-patina-counter') || '7', 10);
      section.querySelectorAll('[data-patina-num]').forEach(function(el){ el.textContent = pad(startCounter); });
      section.querySelectorAll('[data-patina-ordinal]').forEach(function(el){ el.textContent = ordinal(startCounter); });
    }else{
      section.querySelectorAll('[data-patina-num]').forEach(function(el){ el.textContent = pad(id); });
      section.querySelectorAll('[data-patina-ordinal]').forEach(function(el){ el.textContent = ordinal(id); });
    }

    /* Highlight current tier card */
    const purchases = getInt(PATINA_PURCHASES_KEY, 0);
    const tier = getTier(purchases);
    if(!tier) return;
    const cards = section.querySelectorAll('.oren-patina-id-card');
    if(tier === 'drawer' && cards[0]) cards[0].classList.add('active');
    if(tier === 'cabinet' && cards[1]){ cards[0].classList.add('active'); cards[1].classList.add('active'); }
    if(tier === 'cellar'){ cards.forEach(function(c){ c.classList.add('active'); }); }
  }

  /* ============================================
     RETURNING CUSTOMER BANNER
     Shows on every page if customer has Patina ID + hasn't dismissed this session
     ============================================ */
  function renderReturningBanner(){
    const id = getInt(PATINA_KEY, 0);
    if(id === 0) return;

    const dismissed = sessionStorage.getItem(RETURNING_DISMISSED_KEY) === '1';
    if(dismissed) return;

    /* Don't show on order confirmation pages */
    if(location.pathname.includes('/thank') || location.pathname.includes('/orders/')) return;
    if(document.body.classList.contains('template-customers-order')) return;

    const banner = document.querySelector('[data-returning-customer]');
    if(!banner) return;

    const since = getVal(PATINA_SINCE_KEY) || new Date().getFullYear();
    banner.querySelector('[data-patina-id]').textContent = '#' + pad(id);
    banner.querySelector('[data-patina-since]').textContent = since;
    banner.style.display = 'block';

    const dismiss = banner.querySelector('.oren-returning-dismiss');
    if(dismiss){
      dismiss.addEventListener('click', function(){
        try{ sessionStorage.setItem(RETURNING_DISMISSED_KEY, '1'); }catch(e){}
        banner.style.display = 'none';
      });
    }
  }

  /* ============================================
     INIT
     ============================================ */
  function init(){
    assignPatinaIdIfNeeded();
    renderPatinaId();
    renderReturningBanner();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  }else{
    init();
  }
})();
